import React, { useState, useRef, useEffect } from 'react';

interface ZoomableIframeProps {
  viewerUrl: string;
  title: string;
}

const ZoomableIframe: React.FC<ZoomableIframeProps> = ({ viewerUrl, title }) => {
    const [scale, setScale] = useState<number>(1);
    const [showZoomButtons, setShowZoomButtons] = useState<boolean>(window.innerWidth <= 1080);
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const parentRef = useRef<HTMLDivElement>(null);

    const minScale = 1;
    const maxScale = 3;

    const zoomIn = () => {
        if (scale < maxScale) {
            setScale((prevScale) => Math.min(prevScale + 0.1, maxScale));
        }
    };

    const zoomOut = () => {
        if (scale > minScale) {
            setScale((prevScale) => Math.max(prevScale - 0.1, minScale));
        }
    };

    const handleResize = () => {
        setShowZoomButtons(window.innerWidth <= 1080);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div
            ref={parentRef}
            style={{
                position: 'relative',
                width: '100%',
                height: '100%',
                overflow: 'hidden',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <iframe
                ref={iframeRef}
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    transform: `scale(${scale})`,
                    transformOrigin: '0 0',
                    transition: 'transform 0.3s ease',
                }}
                src={viewerUrl}
                title={title}
            />
            {window.VBwidgetConfig.docViewer === '{{url}}' && showZoomButtons && (
                <div
                    style={{
                        position: 'absolute',
                        top: '10px',
                        left: '10px',
                        zIndex: 10,
                        background: 'rgba(0, 0, 0, 0.5)',
                        color: 'white',
                        padding: '5px',
                        borderRadius: '5px',
                    }}
                >
                    <button onClick={zoomIn} disabled={scale >= maxScale} className='vb-btn vb-btn-light vb-btn-sm vb-zoom-btn'>
                        +
                    </button>
                    <button onClick={zoomOut} disabled={scale <= minScale} className='vb-btn vb-btn-light vb-btn-sm vb-zoom-btn'>
                        -
                    </button>
                </div>
            )}
        </div>
    );
};

export default ZoomableIframe;
